import React, { useState } from 'react';
import {
    Button,
    Alert,
    Modal
} from 'react-bootstrap';
import { getAuthenticatedAxios } from './axiosConfig';
import { useAuth } from '../AuthContext/AuthContext';
import { BASE_URL } from '../../Constants/constants';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const StaffCheckoutInitiation = ({ onCheckoutInitiated }) => {
    const { t } = useTranslation('staffInitiation');
    const { currentUser } = useAuth();
    const [error, setError] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const startCheckoutProcess = async () => {
        try {
            if (!currentUser?.id) {
                throw new Error(t('user_authentication_required'));
            }

            setIsLoading(true);
            setShowConfirmModal(false);

            const authenticatedAxios = getAuthenticatedAxios();
            const response = await authenticatedAxios.post(`${BASE_URL}/checkout/start`);

            // ADDED: notify staff by email that checkout has been initiated
            try {
                await axios.post(`${BASE_URL}/notify/checkout-initiated`, {
                    user_id: currentUser.id
                });
            } catch (emailErr) {
                // Email failure should not block the checkout flow
                console.warn('Checkout initiation email failed:', emailErr);
            }

            console.log(t('checkoutProcessStartedSuccessfully'), response.data);
            onCheckoutInitiated(response.data);
            setError(null);

        } catch (err) {
            console.error(t('checkoutProcessInitiationError'), {
                error: err,
                response: err.response,
                message: err.message
            });

            setError(
                err.response?.data?.detail ||
                err.response?.data?.message ||
                err.message ||
                t('failed_to_start_checkout')
            );
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            {error && (
                <Alert variant="danger" dismissible onClose={() => setError(null)}>
                    {error}
                </Alert>
            )}

            <Button
                variant="primary"
                size="lg"
                onClick={() => setShowConfirmModal(true)}
                disabled={isLoading}
            >
                {isLoading ? t('initiating') : t('start_checkout_process')}
            </Button>

            <Modal
                show={showConfirmModal}
                onHide={() => setShowConfirmModal(false)}
                backdrop="static"
                keyboard={!isLoading}
            >
                <Modal.Header closeButton={!isLoading}>
                    <Modal.Title>{t('confirm_checkout_initiation')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {t('checkout_confirmation_message')}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => setShowConfirmModal(false)}
                        disabled={isLoading}
                    >
                        {t('cancel')}
                    </Button>
                    <Button
                        variant="primary"
                        onClick={startCheckoutProcess}
                        disabled={isLoading}
                    >
                        {isLoading ? t('processing') : t('confirm')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default StaffCheckoutInitiation;